var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[
    'main-text',

    {
      'main-text-body': _vm.mode === 'body',
      'main-text-button': _vm.mode === 'button',
      'main-text-caption': _vm.mode === 'caption',
      'main-text-tooltip': _vm.mode === 'tooltip',
      'main-text-badge': _vm.mode === 'badge',
      'main-text-black': _vm.color === 'black',
      'main-text-gray-2': _vm.color === 'gray-2',
      'main-text-primary': _vm.color === 'primary',
    } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }